<template>
    <div class="chart-datetime">
        <div class="horizontal-wrapper" style="margin:auto" v-on:click="e => $refs['datetime']? $refs['datetime'].open(e): 0">
            <p class="display-datetime">{{ dateValueDisplay }}</p>
            <div class="icon" :style="`background-image: url(${require('../images/bars-solid.svg')});`"></div>
        </div>

        <vue-datetime class="datetime hide-input" type="datetime" :title="title" ref="datetime" format="yyyy-MM-dd HH:mm" v-model="dateValue"  />
    </div>
</template>
<script>

export default{
    name: 'chart-datetime',

    props: { value: String, title:String },
    computed:{
        dateValue:{
            get(){
                return this.$props.value
            },
            set(value){
                // the first time on mounted the input event should not be emitted
                // because the parent component has not yet bound the value to the prop 
                if(this.mountedDone)
                    this.$emit('input', value)
            }
        },
        dateValueDisplay(){
            
            return this.$moment(this.dateValue).format('YYYY-MM-DD HH:mm')
        }
    },
    data(){
        return{
            mountedDone: false
        }
    },
    mounted(){

        this.mountedDone = true
    }
}
</script>

<style>
.chart-datetime{
   display: flex;
}

.chart-datetime .display-datetime{
    font-size: 10pt;
    margin: auto;
}
.chart-datetime .icon{
    flex: 0 0 12pt;
    width: 12pt;
    height: 12pt;
    margin: auto 2pt; 
}
.hide-input .vdatetime-input{
    display: none;
}
.datetime .hide-input input{
    display: none;
}

@media screen and (max-device-width: 800px) {/*für mobil*/

    .chart-datetime .display-datetime{
        font-size: 14pt;
    }
}
</style>